module.exports = __webpack_public_path__ + "img/logo.cb2dae68.jpg";